export class SequentialCallbackTask {
    public callbackFunc: () => void | Promise<void>;
}
